<p class="rs-tit3">{{ 'bills.options.title' | translate }}</p>
<ng-container *ngIf="isDeferralCardVisible">
  <p>{{ showDeferralOrNoDeferralReason | translate }}</p>
  <a
    (click)="onPaymentFacilitiesInfoLinkClick()"
    data-cy="myBillOdbDeferralMoreInfoLink"
    class="rs-btn rs-btn-third"
    data-tms-event="button-click"
    data-tms-button-zone="mybill.options"
    data-tms-button-name="more info"
    [attr.data-tms-message-info]="billingAccountNumber"
    [attr.data-tms-context]="documentReference"
    >{{ 'bills.options.moreInfoButtonLabel' | translate }}
    <i class="rs-icon-btn-third rs-margin-left1" aria-hidden="true"></i
  ></a>
  <my-bill-deferral-card
    [customerPaymentProfile]="customerPaymentProfile"
    [partialDeferralCheck]="billDocument.partialDeferralCheck"
    [dueDate]="billDocument.dueDate"
    [deferralDate]="billDocument.deferralDate"
    [documentReference]="documentReference"
    [billingAccountNumber]="billingAccountNumber"
  >
  </my-bill-deferral-card>
</ng-container>
<div class="rs-me"></div>
<a
  (click)="onSettingsLinkClick()"
  class="rs-btn rs-btn-third"
  data-tms-event="button-click"
  data-tms-button-zone="mybill.options"
  data-tms-button-name="manage billing settings"
  [attr.data-tms-message-info]="billingAccountNumber"
  [attr.data-tms-context]="documentReference"
  data-cy="myBillOdbDeferralSettingsLink"
  >{{ settingsLabel }}
  <i class="rs-icon-btn-third rs-margin-left1" aria-hidden="true"></i
></a>
<my-bill-modal-login-required
  [showModal]="showModal"
  [redirectToLoginLink]="redirectLink"
  *ngIf="showModal"
  (hideModal)="onCancel()"
>
</my-bill-modal-login-required>
